import clsx from 'clsx';
import React from 'react';

import { kLabelColumnWidth } from '@fragment/ui/src/components/Payments/LayoutRow';

/** Outer wrapper for a header row (Users / arrows / column labels). */
export const kInvoiceTabHeaderRow =
  'flex flex-row w-full items-center border-b-[0.5px] border-main-200 h-f4';

/**
 * Outer wrapper for a single-height data row. Items tab wraps multiple
 * ItemRows inside a user group so it uses its own h-fit wrapper; Summary
 * rows are one row per user so use this directly.
 */
export const kInvoiceTabDataRow =
  'flex flex-row w-full items-stretch border-b-[0.5px] border-main-200 h-fit';

/** Classes applied to any text that acts as a column header. */
export const kInvoiceTabHeaderText = 'text-main-500 text-xmd';

/** Horizontal padding used inside data cells. */
export const kInvoiceTabCellPadding = 'px-[13.5px]';

/**
 * A flex-grown column used by the Items tab for Name / Qty / Price /
 * Due. Pass a `flex-[N]` string (must be a literal for Tailwind's AOT
 * scan to pick up the arbitrary value) to override the default 1:1
 * share for wider or narrower columns.
 */
export const invoiceTabGrowCell = (flexClass?: string): string =>
  clsx(
    'flex items-center min-w-0 flex-1 basis-0',
    kInvoiceTabCellPadding,
    flexClass
  );

type UsersHeaderCellProps = {
  /** Items tab draws a right border between Users and the direction cells. */
  withRightBorder?: boolean;
};

/**
 * The "Users" label in the left-hand label column. Both tables render
 * the exact same text and sizing; only the separator border differs.
 */
export const UsersHeaderCell = ({
  withRightBorder = false,
}: UsersHeaderCellProps): JSX.Element => (
  <span
    className={clsx(
      kLabelColumnWidth,
      kInvoiceTabHeaderText,
      kInvoiceTabCellPadding,
      'shrink-0 text-left',
      withRightBorder && 'border-r-[0.5px] border-main-200'
    )}
  >
    Users
  </span>
);
